"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveGifSource = void 0;
const resolveGifSource = (src) => {
    if (typeof window === 'undefined') {
        return src;
    }
    return new URL(src, window.origin).href;
};
exports.resolveGifSource = resolveGifSource;
